class CartItem extends HHBaseElement {
  constructor() {
    super()

    this.miniCart = document.querySelector(
      '.mini-cart'
    )

    this.addToCartToggle = this.querySelector(
      '.cart-item__atc'
    )

    this.selectedVariantInput = this.querySelector(
      '.js-selected-variant'
    )

    this._addToCart = this._addToCart.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    if (this.addToCartToggle) {
      this.addToCartToggle.addEventListener('click', this._addToCart)
    }
  }

  _removeListeners() {
    if (this.addToCartToggle) {
      this.addToCartToggle.removeEventListener('click', this._addToCart)
    }
  }

  async _addToCart(e) {
    e.preventDefault()

    if (this.miniCart) {
      this.miniCart.setAttribute('loading', true)
    }

    this.setAttribute('loading', true)
    this.addToCartToggle.setAttribute('disabled', true)

    const payload = {
      id: this.selectedVariantInput.value,
      quantity: 1
    }

    if (this.dataset.isFreeSample) {
      payload.properties = {
        _is_free_sample_: true
      }
    }

    try {
      await window.__CART__CONTROLLER__.add({ payload })
    } finally {
      if (this.miniCart) {
        this.miniCart.removeAttribute('loading')
      }
      this.removeAttribute('loading')
      this.addToCartToggle.setAttribute('disabled', false)
    }
  }
}
window.customElements.define('hh-cart-item', CartItem)
